import ListItem from '@mui/material/ListItem';
import {memo} from 'react';

const MUIListItem = (props: any) => {
    const {onClick, className, ...rest} = props;
    return (
        <ListItem onClick={onClick} className={className} {...rest}>
            {props.children}
        </ListItem>
    );
};

export default memo(MUIListItem);
